export class Fleet {
   constructor() {
     this.id = null;
     this.owner = null;
     this.map = null;
     this.space_slots = null;
     this.air_slots = null;
     this.land_slots = null;
     this.water_slots = null;
     this.location_type = null;
     this.location_id = null;
     this.status = null;
     this.location_list_forward = null;
     this.location_list_backward = null;
     this.command_struct = null;
     this.created_at = null;
     this.updated_at = null;
   }

  /**
   * @return {boolean}
   */
  isOnStation() {
    return this.status === 'onStation';
  }
}

